import { ISalesforceBusinessPartnerCommissionInfo } from '.';
import { IAbstractRecord } from '@models';
import {
  enumListAsRecordObject,
  lookupListAsRecordObject,
} from '@utils/graph-utils';

export function LookupToList(data: any) {
  const lovs: Record<string, Record<string, string>> = {
    lines: {},
  };

  data?.SalesforceManagement?.queries?.getBusinessPartnerLinesListWithoutPagination.forEach(
    (element: {
      salesforceManagement_BusinessPartnerLine_Id: string;
      salesforceManagement_BusinessPartnerLine_LineID: {
        views: {
          PlanConfigManagement_all: {
            properties: {
              Name: string;
            };
          };
        };
      };
    }) => {
      lovs.lines[element.salesforceManagement_BusinessPartnerLine_Id] =
        element.salesforceManagement_BusinessPartnerLine_LineID.views.PlanConfigManagement_all.properties.Name;
    }
  );

  lovs['commissionTypes'] = enumListAsRecordObject(
    data?.Core_CommissionTypes?.enumValues as {
      __typename: string;
      name: string;
    }[]
  );

  lovs['commissionApplicableOnOptions'] = lookupListAsRecordObject(
    data?.Core?.lookups?.commissionApplicableOnOptions
  );

  return lovs;
}

export function extractLines(
  data: any
): Record<string, Record<string, string>> {
  const lovs: Record<string, Record<string, string>> = {
    lines: {},
  };

  data?.SalesforceManagement?.queries?.getBusinessPartnerLinesListWithoutPagination.forEach(
    (element: {
      salesforceManagement_BusinessPartnerLine_Id: string;
      salesforceManagement_BusinessPartnerLine_LineID: {
        id: string;
        views: {
          PlanConfigManagement_all: {
            properties: {
              Name: string;
            };
          };
        };
      };
    }) => {
      lovs.lines[element.salesforceManagement_BusinessPartnerLine_LineID.id] =
        element.salesforceManagement_BusinessPartnerLine_LineID.views.PlanConfigManagement_all.properties.Name;
    }
  );

  return lovs;
}

export function extractPlans(
  data: any
): Record<string, Record<string, string>> {
  const lovs: Record<string, Record<string, string>> = {
    plans: {},
  };

  data?.SalesforceManagement?.queries?.GetPlanListByAssignedLines.forEach(
    (element: {
      planConfigManagement_Plan_Id: string;
      planConfigManagement_Plan_Name: string;
    }) => {
      lovs.plans[element.planConfigManagement_Plan_Id] =
        element.planConfigManagement_Plan_Name;
    }
  );

  return lovs;
}
export function graphqlToSalesforceBusinessPartnerCommissionInfo(
  data: any
): ISalesforceBusinessPartnerCommissionInfo {
  const businessPartnerLine =
    data?.SalesforceManagement?.entities?.businessPartnerLine?.views
      ?.SalesforceManagement_all?.properties;
  return {
    assignedLineId: '',
    commissionType: businessPartnerLine?.LineCommissionType,
    lineCommissionValue: businessPartnerLine?.LineCommissionValue,
    lineCommissionValueCurrency:
      businessPartnerLine?.LineCommissionValueCurrency?.Title,
    lineCommissionRate: businessPartnerLine?.LineCommissionRate,
    lineCommissionApplicableOn:
      businessPartnerLine?.LineCommissionApplicableOn?.Title,
    activeFrom: businessPartnerLine?.activeFrom,
    activeTo: businessPartnerLine?.activeTo,
  };
}

export const mapToDetailedSelection = (item: IAbstractRecord): any => {
  const result: IAbstractRecord = {};
  result.businessPartnerStatus =
    item['salesforceManagement_BusinessPartner_Status'];
  result.businessPartnerPlanStatus =
    item['salesforceManagement_BusinessPartnerPlan_Status'];
  result.businessPartnerPlan_BusinessPartnerLine_Status =
    item[
      'salesforceManagement_BusinessPartnerPlan_BusinessPartnerLineID_Status'
    ];
  result.businessPartnerPlan_Line_Status = item['line_Status'];
  result.businessPartnerPlan_Plan_Status = item['plan_PlanStatus'];

  result.businessPartnerCommissionType =
    item['salesforceManagement_BusinessPartnerPlan_PlanCommissionType'];
  result.businessPartnerCommissionValue =
    item['salesforceManagement_BusinessPartnerPlan_PlanCommissionValue_Only'];
  result.businessPartnerCommissionValueCurrency =
    item[
      'salesforceManagement_BusinessPartnerPlan_PlanCommissionValueCurrency_Only'
    ];
  result.businessPartnerCommissionRate =
    item['salesforceManagement_BusinessPartnerPlan_PlanCommissionRate_Only'];
  result.businessPartnerCommissionApplicableOn =
    item['salesforceManagement_BusinessPartnerPlan_ApplicableOnCode'];
  result.businessPartnerActiveFrom =
    item['salesforceManagement_BusinessPartnerPlan_ActiveFrom'];
  result.businessPartnerActiveTo =
    item['salesforceManagement_BusinessPartnerPlan_ActiveTo'];

  result.salesforceManagement_BusinessPartnerPlan_BusinessPartnerLineID_LineCommissionType =
    item[
      'salesforceManagement_BusinessPartnerPlan_BusinessPartnerLineID_LineCommissionType'
    ];
  result.salesforceManagement_BusinessPartnerPlan_BusinessPartnerLineID_LineCommissionValue =
    item[
      'salesforceManagement_BusinessPartnerPlan_BusinessPartnerLineID_LineCommissionValue'
    ];
  result.salesforceManagement_BusinessPartnerPlan_BusinessPartnerLineID_ValueCurrency =
    item[
      'salesforceManagement_BusinessPartnerPlan_BusinessPartnerLineID_ValueCurrency'
    ];
  result.salesforceManagement_BusinessPartnerPlan_BusinessPartnerLineID_LineCommissionRate =
    item[
      'salesforceManagement_BusinessPartnerPlan_BusinessPartnerLineID_LineCommissionRate'
    ];
  result.salesforceManagement_BusinessPartnerPlan_BusinessPartnerLineID_ApplicableOn =
    item[
      'salesforceManagement_BusinessPartnerPlan_BusinessPartnerLineID_ApplicableOn'
    ];

  result.salesforceManagement_BusinessPartnerPlan_Plan_SpecialCommissionApplicable =
    item[
      'salesforceManagement_BusinessPartnerPlan_Plan_SpecialCommissionApplicable'
    ];
  result.salesforceManagement_BusinessPartnerPlan_Plan_SpecialCommissionType =
    item['salesforceManagement_BusinessPartnerPlan_Plan_SpecialCommissionType'];
  result.salesforceManagement_BusinessPartnerPlan_Plan_SpecialCommissionValue =
    item[
      'salesforceManagement_BusinessPartnerPlan_Plan_SpecialCommissionValue'
    ];
  result.salesforceManagement_BusinessPartnerPlan_Plan_SpecialCommissionValueCurrency =
    item[
      'salesforceManagement_BusinessPartnerPlan_Plan_SpecialCommissionValueCurrency'
    ];
  result.salesforceManagement_BusinessPartnerPlan_Plan_SpecialCommissionRate =
    item['salesforceManagement_BusinessPartnerPlan_Plan_SpecialCommissionRate'];
  result.salesforceManagement_BusinessPartnerPlan_Plan_SpecialCommissionApplicableOn =
    item[
      'salesforceManagement_BusinessPartnerPlan_Plan_SpecialCommissionApplicableOn'
    ];

  return result;
};
